// the report page links in here too. keep the module import-free: a value caught in an
// import cycle reads as undefined
export const DetailsTabs = {
    flags: 'flags',
    documents: 'documents',
    structure_compliance: 'structure_compliance',
    offer: 'offer',
    raa: 'raa',
    notes: 'notes',
} as const;

export type DetailsTabs = (typeof DetailsTabs)[keyof typeof DetailsTabs];
